export default "__VITE_ASSET__61ebef3b__"